module.exports = __webpack_public_path__ + "img/ElderlyOutlined.294d176f.svg";